export default __webpack_public_path__ + "static/productImage-9229aca24443f49481e7b5822966b9a3.png";